'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _languageHandler = require('../languageHandler');

var _AutocompleteProvider2 = require('./AutocompleteProvider');

var _AutocompleteProvider3 = _interopRequireDefault(_AutocompleteProvider2);

var _MatrixClientPeg = require('../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _QueryMatcher = require('./QueryMatcher');

var _QueryMatcher2 = _interopRequireDefault(_QueryMatcher);

var _Components = require('./Components');

var _index = require('../index');

var _index2 = _interopRequireDefault(_index);

var _sortBy2 = require('lodash/sortBy');

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _Permalinks = require('../utils/permalinks/Permalinks');

var _FlairStore = require('../stores/FlairStore');

var _FlairStore2 = _interopRequireDefault(_FlairStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2018 New Vector Ltd
Copyright 2018 Michael Telatynski <7t3chguy@gmail.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var COMMUNITY_REGEX = /\B\+\S*/g;

function score(query, space) {
    var index = space.indexOf(query);
    if (index === -1) {
        return Infinity;
    } else {
        return index;
    }
}

var CommunityProvider = function (_AutocompleteProvider) {
    (0, _inherits3.default)(CommunityProvider, _AutocompleteProvider);

    function CommunityProvider() {
        (0, _classCallCheck3.default)(this, CommunityProvider);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CommunityProvider.__proto__ || (0, _getPrototypeOf2.default)(CommunityProvider)).call(this, COMMUNITY_REGEX));

        _this.matcher = new _QueryMatcher2.default([], {
            keys: ['groupId', 'name', 'shortDescription']
        });
        return _this;
    }

    (0, _createClass3.default)(CommunityProvider, [{
        key: 'getCompletions',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(query, selection) {
                var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var BaseAvatar, cli, completions, _getCurrentCommand, command, range, joinedGroups, groups, matchedString;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                BaseAvatar = _index2.default.getComponent('views.avatars.BaseAvatar');

                                // Disable autocompletions when composing commands because of various issues
                                // (see https://github.com/vector-im/riot-web/issues/4762)

                                if (!/^(\/join|\/leave)/.test(query)) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return', []);

                            case 3:
                                cli = _MatrixClientPeg2.default.get();
                                completions = [];
                                _getCurrentCommand = this.getCurrentCommand(query, selection, force), command = _getCurrentCommand.command, range = _getCurrentCommand.range;

                                if (!command) {
                                    _context.next = 15;
                                    break;
                                }

                                joinedGroups = cli.getGroups().filter(function (_ref2) {
                                    var myMembership = _ref2.myMembership;
                                    return myMembership === 'join';
                                });
                                _context.next = 10;
                                return (0, _bluebird.resolve)(_promise2.default.all(joinedGroups.map(function () {
                                    var _ref3 = (0, _bluebird.method)(function (_ref4) {
                                        var groupId = _ref4.groupId;

                                        try {
                                            return _FlairStore2.default.getGroupProfileCached(cli, groupId);
                                        } catch (e) {
                                            // if FlairStore failed, fall back to just groupId
                                            return _promise2.default.resolve({
                                                name: '',
                                                groupId: groupId,
                                                avatarUrl: '',
                                                shortDescription: ''
                                            });
                                        }
                                    });

                                    return function (_x5) {
                                        return _ref3.apply(this, arguments);
                                    };
                                }())));

                            case 10:
                                groups = _context.sent;


                                this.matcher.setObjects(groups);

                                matchedString = command[0];

                                completions = this.matcher.match(matchedString);
                                completions = (0, _sortBy3.default)(completions, [function (c) {
                                    return score(matchedString, c.groupId);
                                }, function (c) {
                                    return c.groupId.length;
                                }]).map(function (_ref5) {
                                    var avatarUrl = _ref5.avatarUrl,
                                        groupId = _ref5.groupId,
                                        name = _ref5.name;
                                    return {
                                        completion: groupId,
                                        suffix: ' ',
                                        type: "community",
                                        href: (0, _Permalinks.makeGroupPermalink)(groupId),
                                        component: _react2.default.createElement(_Components.PillCompletion, { initialComponent: _react2.default.createElement(BaseAvatar, { name: name || groupId,
                                                width: 24, height: 24,
                                                url: avatarUrl ? cli.mxcUrlToHttp(avatarUrl, 24, 24) : null }), title: name, description: groupId }),
                                        range: range
                                    };
                                }).slice(0, 4);

                            case 15:
                                return _context.abrupt('return', completions);

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getCompletions(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return getCompletions;
        }()
    }, {
        key: 'getName',
        value: function getName() {
            return '💬 ' + (0, _languageHandler._t)('Communities');
        }
    }, {
        key: 'renderCompletions',
        value: function renderCompletions(completions) {
            return _react2.default.createElement(
                'div',
                {
                    className: 'mx_Autocomplete_Completion_container_pill mx_Autocomplete_Completion_container_truncate',
                    role: 'listbox',
                    'aria-label': (0, _languageHandler._t)("Community Autocomplete")
                },
                completions
            );
        }
    }]);
    return CommunityProvider;
}(_AutocompleteProvider3.default);

exports.default = CommunityProvider;
module.exports = exports['default'];
//# sourceMappingURL=CommunityProvider.js.map